import { BannerType, VideoBannerType } from "@/common/lib/types";
import PlpVideoBannerView from "./PlpVideoBannerView";
import PlpImageBannerView from "./PlpImageBannerView";

interface IProps {
  content: BannerType | VideoBannerType;
  locale: string;
}
const PlpBannerWidget = ({ content, locale }: IProps) => {
  if (content?.bannerType === "video" || content?.bannerType === "largeVideo")
    return <PlpVideoBannerView content={content as VideoBannerType} locale={locale} />;
  else return <PlpImageBannerView content={content as BannerType} locale={locale} />;
};

export default PlpBannerWidget;
